import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import otherTypeService from "../../service/otherType";
import { OtherType, OtherTypeState } from "../../@type/otherType";


export const getOtherType = createAsyncThunk(
    "get/getOtherType",
    async (type: string) => {
      const { data } = await otherTypeService.get(type);
      return data;
    }
  );
  export const getByOtherTypeId = createAsyncThunk(
    "get/getByIDCategory",
    async (id: any) => {
      const { data } = await otherTypeService.getById(id);
      return data;
    }
  );
  export const postOtherType = createAsyncThunk(
    "post/postOtherType",
    async (OtherTypeData: any) => {
      const { data } = await otherTypeService.post(OtherTypeData);
      return data;
    }
  );

    export const updateOtherType = createAsyncThunk(
    "update/updateOtherType",
    async ({ id, a }: { id: number, a: OtherType }) => {
      const { data } = await otherTypeService.updateById(id, a);
      return data;
    }
  );
     export const deleteOtherType = createAsyncThunk(
    "delete/deleteOtherType",
    async (id: number) => {
      const { data } = await otherTypeService.delete(id);
      return data;
    }
  );
const initialState: OtherTypeState = {
  otherTypeList: [],
  otherTypeDetail: {
    id:0,
   title:"",
    description:"",
    type:"",
    images:[]
  }
};

const OtherTypeSlice = createSlice({
  name: "OtherType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOtherType.fulfilled, (state, action) => {
      state.otherTypeList = action.payload;
    });
    builder.addCase(postOtherType.fulfilled, (state, action) => {
      state.otherTypeList.push(action.payload);
    }); 
    builder.addCase(getByOtherTypeId.fulfilled, (state, action) => {
      state.otherTypeDetail = action.payload;
    });
    builder.addCase(updateOtherType.fulfilled, (state, action) => {
      state.otherTypeDetail = action.payload;

    });
     builder.addCase(deleteOtherType.fulfilled, (state, action) => {
      state.otherTypeList.push(action.payload);
    }); 
  },
});

export default OtherTypeSlice.reducer;
